import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {
	updateStage,
	requestRoomKey,
	subscribeToRoomConfig,
	updateStepData,
	updateLanguage,
	submitTestResults,
	submitCandidateInfo,
	startTimer as apiStartTimer,
	endTimer as apiEndTimer,
	pingServer,
	pingClient,
	subscribeToIdentityProvision,
	subscribeToClientPong,
	subscribeToMasterPing,
	subscribeToServerPong,
	masterPong,
	subscribeToSocketLifecycle,
	subscribeToServerInfo,
	subscribeToRoomDeleted,
	notifyAdminClosed
} from '../../api';
import {ENVIRONMENT} from '../../constants';
import {tests} from '../../constants/tests';

import SpoonerismAdmin from '../../tests/Spoonerism/Admin';
import LetterKnowledgeAdmin from '../../tests/LetterKnowledge/Admin';
import WorkingMemoryAdmin from '../../tests/WorkingMemory/Admin';
import OneMinuteAdmin from '../../tests/OneMinute/Admin';
import RapidNamingAdmin from '../../tests/RapidNaming/Admin';
import PhonemeIsolationAdmin from '../../tests/PhonemeIsolation/Admin';
import PhonemeDeletionAdmin from '../../tests/PhonemeDeletion/Admin';
import WordDictationAdmin from '../../tests/WordDictation/Admin';
import SentenceMemoryAdmin from 'tests/SentenceMemory/Admin';
import TestComplete from '../../components/TestComplete';
import NonwordRepetitionAdmin from 'tests/NonwordRepetition/Admin';

import getTestKeyGrade from '../../endpoints/getTestKeyGrade';

import queryString from 'query-string';
import {getNameFromNumber, getTestsForClass,tryGetNameFromNumber,tryGetTestsForClass} from 'utils/testUtils';

import {createResults} from '../../utils/resultsUtils';

import TestIntro from '../../components/TestIntro';
import ConnectionStatus from '../../components/ConnectionStatus';
import ProgressIndication from '../../components/ProgressIndication';

import './styles.scss';
import strings from '../../strings';

const parsedSearch = queryString.parse(window.location.search);
let search = parsedSearch;
		let params = new URLSearchParams(search);
		let token = params.get('token');

const getTestFromName = (testName) => {
	switch (testName) {
		case 'Spoonerism':
			return SpoonerismAdmin;
		case 'LetterKnowledge':
			return LetterKnowledgeAdmin;
		case 'WorkingMemory':
			return WorkingMemoryAdmin;
		case 'RapidNaming':
			return RapidNamingAdmin;
		case 'PhonemeDeletion':
			return PhonemeDeletionAdmin;
		case 'PhonemeIsolation':
			return PhonemeIsolationAdmin;
		case 'OneMinute':
			return OneMinuteAdmin;
		case 'WordDictation':
			return WordDictationAdmin;
		case 'TestComplete':
			return TestComplete;
		case 'SentenceMemory':
			return SentenceMemoryAdmin;
		case 'NonwordRepetition':
      		return NonwordRepetitionAdmin
		default:
			return null;
	}
};

class TestAdmin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			roomConfig: null,
			ageGroup: null || this.props.ageGroup,
			test: 0,
			step: 0,
			stage: 0,
			lastServerPong: moment().subtract(10, 'second'),
			lastClientPong: moment().subtract(10, 'second'),
			netStatus: 'disconnected',
      		netHint: null,
		};

				this._lastTimerKey = null; 
this._lastStageKey = null;    
this._openTimers = new Set();  


	}

		componentDidMount() {
  var self = this;
  this._onPageHide = function () {
    var key = self.state && self.state.roomConfig && self.state.roomConfig.key;
    if (key) notifyAdminClosed(key);
  };

  this._onBeforeUnload = function () {
    var key = self.state && self.state.roomConfig && self.state.roomConfig.key;
    if (key) notifyAdminClosed(key);
  };

  window.addEventListener('pagehide', this._onPageHide);
  window.addEventListener('beforeunload', this._onBeforeUnload);


  this._unsubServerInfo = subscribeToServerInfo(function (info) {

    if (info && info.restarted) {
      self.setState({
        netHint: 'server restarted',
        netStatus: 'connected',
        lastServerPong: moment(),
        lastClientPong: moment(),
      });
      try {
        if (window.socket && typeof window.socket.emit === 'function') {
          var ident = (typeof window.getIdentity === 'function') ? window.getIdentity() : null;
          window.socket.emit('get room config', ident);
        }
      } catch (e) {}
    }
  });

		this._unsubRoomCfg = subscribeToRoomConfig((roomConfig) => {


	var safeAge = (roomConfig && (roomConfig.ageGroup === 0 || typeof roomConfig.ageGroup === 'number'))
    ? roomConfig.ageGroup
    : (typeof this.state.ageGroup !== 'undefined' ? this.state.ageGroup : null);


    if (ENVIRONMENT !== 'production') console.log('roomconfig', roomConfig);
     this.setState({
    roomConfig: roomConfig,
    test: roomConfig.currentTest,
    stage: roomConfig.currentStage,
    step: roomConfig.currentStep,
    candidateReady: roomConfig.candidateReady,
    stepData: roomConfig.stepData,
    ageGroup: safeAge
  });
  var hasValidAge = (safeAge === 0) || (typeof safeAge === 'number' && !isNaN(safeAge)) || (typeof safeAge === 'string' && safeAge.length > 0);
  var hasTestIndex = (roomConfig && roomConfig.currentTest != null);
  if (!hasValidAge || !hasTestIndex) return;

  var testName = tryGetNameFromNumber(roomConfig.currentTest, safeAge, this.props.testKeyType);
  if (!testName) return; // plan not ready or index out of range yet
	
  var currentTest = null;
  if (testName === 'RapidNaming') {
    currentTest = tests[testName](safeAge);
  } else if (testName === 'LetterKnowledge' || testName === 'PhonemeIsolation') {
    currentTest = tests[testName](this.props.testKeyType, safeAge);
  } else if (tests[testName]) {
    currentTest = tests[testName]();
  }



  var stageName = (currentTest && currentTest.stages)
  ? currentTest.stages[roomConfig.currentStage]
  : null;
var stageKey = String(roomConfig.currentTest) + '|' + String(roomConfig.currentStage);
if (this._lastStageKey !== stageKey) {
  this._lastStageKey = stageKey;
  this._lastTimerKey = null;   // allow a new first start in this stage
  // entering Intro means no active item timers
  if (stageName === 'Intro') this._openTimers.clear();
}
// close stale timers from previous runs in THIS  stage 
// step 49 started last night and never ended
if (stageName === 'Test' || stageName === 'words') {
  var times = roomConfig.times || {};
  var t  = roomConfig.currentTest;
  var st = roomConfig.currentStage;
  var prefix = String(t) + ' ' + String(st) + ' ';

  
  var stepMap = {};
  Object.keys(times).forEach(function (k) {
    if (k.indexOf(prefix) !== 0) return;
    var parts = k.split(' ');  
    if (parts.length < 4) return;
    var stepIdx = parseInt(parts[2], 10);
    var kind = parts[3]; 
    if (!Number.isFinite(stepIdx)) return;

    var rec = stepMap[stepIdx] || (stepMap[stepIdx] = {});
    if (kind === 'start' && typeof times[k] === 'number') rec.start = times[k];
    if (kind === 'end'   && typeof times[k] === 'number') rec.end   = times[k];
  });

  Object.keys(stepMap).forEach(function (k) {
    var stepIdx = parseInt(k, 10);
    var rec = stepMap[stepIdx];
    var hasStart = typeof rec.start === 'number';
    var hasEnd   = typeof rec.end   === 'number';
    var badOrder = hasStart && hasEnd && (rec.end < rec.start);

    if (hasStart && (!hasEnd || badOrder) && stepIdx !== roomConfig.currentStep) {
      try { apiEndTimer(t, st, stepIdx); } catch (e) {}
    }
  });
}

  var stagesLen = (currentTest && currentTest.stages && typeof currentTest.stages.length === 'number')
    ? currentTest.stages.length : 0;

 
  if (stagesLen > 0 && roomConfig.currentStage >= stagesLen) {
    if (!this._sentStageFix) {
      this._sentStageFix = true;
      try { updateStage(roomConfig.currentTest, 0, 0); } catch (e) {}
    }
    return; 
  } else {
    this._sentStageFix = false;
  }

  if (roomConfig.currentStage === 0 && currentTest && typeof currentTest.getIntroSteps === 'function') {
    var introLen = currentTest.getIntroSteps().length || 0;
    if (introLen > 0 && roomConfig.currentStep >= introLen) {
      try { updateStage(roomConfig.currentTest, 0, 0); } catch (e) {}
      return;
    }
  }
  if (roomConfig.currentStage === 1 && currentTest && typeof currentTest.getSteps === 'function') {
    var stepsLen = currentTest.getSteps().length || 0;
    if (stepsLen > 0 && roomConfig.currentStep >= stepsLen) {
      try { updateStage(roomConfig.currentTest, 1, 0); } catch (e) {}
      return;
    }
  }

				  // ---- start timer once the server confirms a new active step ----
var readyTriplet =
  (roomConfig.currentTest != null &&
   roomConfig.currentStage != null &&
   roomConfig.currentStep != null);

if (readyTriplet && (stageName === 'Test' || stageName === 'words')) {
  var timerKey = String(roomConfig.currentTest) + '|' +
                 String(roomConfig.currentStage) + '|' +
                 String(roomConfig.currentStep);
  if (this._lastTimerKey !== timerKey) {
    this._lastTimerKey = timerKey;
    this._openTimers.add(timerKey);
    try {
      apiStartTimer(roomConfig.currentTest, roomConfig.currentStage, roomConfig.currentStep);
    } catch (e) {}
  }
}
});

  this._unsubLifecycle = subscribeToSocketLifecycle({
    onConnect: function () {
      self.setState({
        netStatus: 'connected',
        netHint: null,
        lastServerPong: moment(),
        lastClientPong: moment()
      });
      try { pingServer(); } catch(e){}
      try { pingClient(); } catch(e){}
      try {
        if (window.socket && typeof window.socket.emit === 'function') {
          var ident = (typeof window.getIdentity === 'function') ? window.getIdentity() : null;
          window.socket.emit('get room config', ident);
        }
      } catch(e){}
    },
    onReconnectAttempt: function (n) {
      self.setState({ netStatus: 'reconnecting', netHint: 'reconnect attempt ' + String(n) });
    },
    onReconnect: function () {
      self.setState({
        netStatus: 'connected',
        netHint: 'reconnected',
        lastServerPong: moment(),
        lastClientPong: moment()
      });
      try { pingServer(); } catch(e){}
      try { pingClient(); } catch(e){}
    },
    onDisconnect: function (reason) {
      self.setState({ netStatus: 'disconnected', netHint: reason || null });
    },
    onConnectError: function (err) {
      var hint = (err && err.message) ? err.message : 'connect error';
      self.setState({ netStatus: 'disconnected', netHint: hint });
    }
  });

   this._unsubRoomDeleted = subscribeToRoomDeleted(function (payload) {
    var currentKey = self.state && self.state.roomConfig && self.state.roomConfig.key;
    if (currentKey && payload && payload.key && payload.key !== currentKey) return;

    try { clearInterval(self.serverPingInterval); } catch (e) {}
    try { clearInterval(self.clientPingInterval); } catch (e) {}

    self.setState({
      netStatus: 'disconnected',
      netHint: (payload && payload.reason) ? payload.reason : 'room deleted',
      roomConfig: null,
      step: 0,
      stage: 0,
      test: 0
    });

    // May be we should show a "finished" screen 
    setTimeout(function () { window.location.href = '/'; }, 500);
  });


  // identity + requesting a room key
  this._unsubIdentity = subscribeToIdentityProvision(function () {
    requestRoomKey(self.props.testKey, token);
  });

  // initial room key request (after subscribing)
  requestRoomKey(this.props.testKey, token);

  // periodic ping monitors
  this.startConnectionMonitoring();

  getTestKeyGrade(this.props.testKey).then(function (results) {
     
      self.setState({
      
        userInformation: results.userInfo
      });
    });

  // optional: prefetch continued test info
 /*  if (this.props.testContinued) {
    getTestKeyInfo(this.props.testKey).then(function (results) {
      console.log('Q han ', results.userInfo, results);
      self.setState({
        subTestsTaken: results.subTestsTaken,
        userInformation: results.userInfo
      });
    });
  } */
}

	startConnectionMonitoring = () => {
		subscribeToServerPong((payload) => {
			this.setState({
				lastServerPong: moment(),
			});
		});
		subscribeToClientPong((payload) => {
			this.setState({
				lastClientPong: moment(),
			});
		});
		subscribeToMasterPing((payload) => {
			masterPong(payload);
		});

		pingServer();
		pingClient();
		this.serverPingInterval = setInterval(pingServer, 5000);
		this.clientPingInterval = setInterval(pingClient, 5000);
	};

componentWillUnmount() {
  clearInterval(this.serverPingInterval);
  clearInterval(this.clientPingInterval);
  if (this._unsubServerInfo) this._unsubServerInfo();
  if (this._unsubRoomCfg) this._unsubRoomCfg();
  if (this._unsubLifecycle) this._unsubLifecycle();
  if (this._unsubIdentity) this._unsubIdentity();

   if (this._unsubRoomDeleted) {
    try { this._unsubRoomDeleted(); } catch (e) {}
  }

  try { window.removeEventListener('pagehide', this._onPageHide); } catch (e) {}
  try { window.removeEventListener('beforeunload', this._onBeforeUnload); } catch (e) {}

}

makeCurrentTest = (testName, ageGroup) => {
  if (!testName) return null;

  if (testName === 'RapidNaming') {
    return tests[testName](ageGroup);                         // (ageGroup)
  }
  if (testName === 'LetterKnowledge' || testName === 'PhonemeIsolation') {
    return tests[testName](this.props.testKeyType, ageGroup); // (testKeyType, ageGroup)
  }
  if (testName === 'WordDictation') {
    return tests[testName](this.props.testKeyType);           // (testKeyType)
  }

   if (testName === 'SentenceMemory') {
    return tests[testName](this.props.testKeyType, ageGroup); 
  }

  // WorkingMemory / OneMinute / Spoonerism / PhonemeDeletion
  return tests[testName] ? tests[testName]() : null;          // ()
};


	nextStep = (results) => {
  const { roomConfig } = this.state;
  if (!roomConfig) return;

  let testName;
  try {
    testName = getNameFromNumber(roomConfig.currentTest, roomConfig.ageGroup, this.props.testKeyType);
  } catch (e) { return; }

  const currentTest = this.makeCurrentTest(testName, roomConfig.ageGroup);
  if (!currentTest) return;

  const stage = roomConfig.currentStage;
  let stepCount = 0;

  if (testName === 'WorkingMemory') {
    if (stage === 0) stepCount = currentTest.getIntroSteps().length;
    else if (stage === 1) stepCount = currentTest.getNumberTrialSteps().length;
    else if (stage === 2) stepCount = 0;
    else if (stage === 3) stepCount = currentTest.getNumberSteps().length;
    else if (stage === 4) stepCount = 0;
    else if (stage === 5) stepCount = currentTest.getIntroSteps().length;
    else if (stage === 6) stepCount = currentTest.getWordSteps().length;
    else if (stage === 7) stepCount = 0;

  }  else if (testName === 'SentenceMemory') {
			if (stage === 0) stepCount = currentTest.getIntroSteps().length;
			else if (stage === 1) {
				stepCount = currentTest.getTrialSteps().length;
			} else if (stage === 2) stepCount = 0;
			else if (stage === 3)
				stepCount = currentTest.getSentenceSteps(
					this.props.testKeyType,
					roomConfig.ageGroup
				).length;
			else if (stage === 4) stepCount = 0;
		}
  else if (testName === 'NonwordRepetition') {
			if (stage === 0) stepCount = currentTest.getIntroSteps().length;
			else if (stage === 1)
				stepCount = currentTest.getTrialSteps().length;
			else if (stage === 2) stepCount = 0; // pause after trial
			else if (stage === 3)
				stepCount = currentTest.getNonwordSteps().length;
			else if (stage === 4) stepCount = 0; // final pause
		}


  else {
    if (stage === 0) stepCount = currentTest.getIntroSteps().length;
    else if (stage === 1) stepCount = currentTest.getSteps().length; // RN = ALL images (flattened)
    else if (stage === 2) stepCount = 0;
  }

  const step = roomConfig.currentStep;
  if (step >= stepCount - 1) {
    this.nextStage(results);
  } else {
    updateStage(roomConfig.currentTest, stage, step + 1);
  }
};

	nextStage = (answers) => {
  const { roomConfig } = this.state;
  if (!roomConfig) return;

  let testName;
  try {
    testName = getNameFromNumber(roomConfig.currentTest, roomConfig.ageGroup, this.props.testKeyType);
  } catch (e) { return; }

  const currentTest = this.makeCurrentTest(testName, roomConfig.ageGroup);
  if (!currentTest) return;

  const stage = roomConfig.currentStage;
  const stageName = (currentTest.stages && currentTest.stages[stage]) || null;

  const vars = {};
  if (stageName === 'Intro') {
    vars.startTime = new Date();
  } else if (stageName === 'Test' || stageName === 'words') {
    vars.endTime = new Date();
    if (answers) this.submitResults(answers, vars);

    
    if (this._openTimers.size) {
      const testNum = roomConfig.currentTest;
      const stageNum = roomConfig.currentStage;
      
      Array.from(this._openTimers).forEach((k) => {
        const [t, st, sp] = k.split('|').map(Number);
        if (t === testNum && st === stageNum) {
          try { apiEndTimer(testNum, stageNum, sp); } catch (e) {}
          this._openTimers.delete(k);
        }
      });
    }
  }

  // advance stage
  if (stage >= currentTest.stages.length - 1) {
    updateStage(roomConfig.currentTest + 1, 0, 0, vars);
  } else {
    updateStage(roomConfig.currentTest, stage + 1, 0, vars);
  }
};
	nextTest = () => {
		const {test} = this.state;
		if (test > tests.length - 1) {
		} else {
			const newTest = test + 1;
			this.setState({
				test: newTest,
				step: 0,
				stage: 0,
			});
			updateStage(newTest, 0, 0);
		}
	};

	submitResults = (answers, vars = null, timers = null) => {
		const {roomConfig} = this.state;
		const token = localStorage.getItem('authtoken-child');
		const {testId, results} = createResults(
			roomConfig,
			answers,
			vars,
			timers,
			this.props.testKeyType
		);

		submitTestResults(testId, results, token);
	};

	updateStepData = (stepData) => {
		updateStepData(stepData);
	};
	updateLanguage = (lang) => {
		updateLanguage(lang);
	};

		submitCandidateInfo = (candidateInfo, continued) => {
		const {roomConfig} = this.state;
		  const urlToken = (new URLSearchParams(window.location.search)).get('token');
  const lsToken  = localStorage.getItem('authtoken-child');
  const reduxTok = this.props.token; // from mapStateToProps
  const authToken = lsToken || urlToken || reduxTok || null;

		const info = {
			...candidateInfo,
			adminId:
				this.props.testKeyType === 'youth-followup' ||
				this.props.testKeyType === 'adult-followup' ||
				this.props.testKeyType === 'child-followup'
					? this.props.adminId
					: roomConfig.candidateInfo.adminId,
		};
		  if (!authToken) {
    console.warn('[submitCandidateInfo] No auth token found; backend may reject in prod.');
  }

		submitCandidateInfo(roomConfig.key, info, authToken, continued);
	};

	goToTest = (e, test) => {
		if (e) e.preventDefault();
		updateStage(Number(test), 0, 0);
	};
	startTimer = () => {
		  const rc = this.state.roomConfig;
  if (!rc) return;
  try { apiStartTimer(rc.currentTest, rc.currentStage, rc.currentStep); } catch (e) {}

	};
	endTimer = (step) => {
  const rc = this.state.roomConfig; if (!rc) return;
  const s = (typeof step === 'number') ? step : rc.currentStep;
  const key = `${rc.currentTest}|${rc.currentStage}|${s}`;

  if (this._openTimers.has(key)) {
    this._openTimers.delete(key);
    try { apiEndTimer(rc.currentTest, rc.currentStage, s); } catch (e) {}
  }
};


	onTestIntroComplete = (candidateInfo) => {
		const ageNum = Number(candidateInfo.class);

		const myInfo = {...candidateInfo, ageGroup: ageNum};
		this.submitCandidateInfo(myInfo, Boolean(this.state.userInformation || this.props.testContinued));

		this.setState({
			ageGroup: myInfo.ageGroup,
			test: 1,
		});
		//updateStage(1, 0, 0); //removed since it forced the tests to resumed from the intro part which we do not wnat
	};

	returnProperTestIntro = (isValidTest,roomConfig) =>{
		let TestIntorToReturn= null;
		{(!this.state.userInformation || !this.props.testContinued) && !isValidTest &&  (
			TestIntorToReturn = (<TestIntro
				roomKey={roomConfig.key}
				isClientReady={roomConfig.testUserId}
				onReadyClick={this.onTestIntroComplete}
				testKeyType={this.props.testKeyType}
				updateCandidateInfo={this.updateCandidateInfo}
				updateLanguage={this.updateLanguage}
				userInformation={this.state.userInformation}
				subTestsTaken= {this.state.subTestsTaken}
        ageGroup={roomConfig.ageGroup}
			/>)
		)}
		return TestIntorToReturn;
	}

		render() {
		const {
			roomConfig,
			lastServerPong,
			lastClientPong,
		} = this.state;

		const {  netStatus, netHint } = this.state;

const serverOK = lastServerPong && Math.abs(lastServerPong.diff(moment(), 'second')) < 5;
const clientOK = lastClientPong && Math.abs(lastClientPong.diff(moment(), 'second')) < 5;

var displayStatus = 'disconnected';
var displayHint   = netHint || null;
var socketOK      = (netStatus === 'connected' || netStatus === 'reconnected');


if (serverOK && clientOK) {
  // both pings fresh -> connected
  displayStatus = 'connected';
  displayHint   = null;
} else if (socketOK) {
  // socket says we're up but a ping is stale -> recovering/degraded
  displayStatus = 'reconnecting';
  if (!displayHint) {
    displayHint = (!serverOK ? 'server unreachable' : 'client unreachable');
  }
} else {
  // sockets not up -> using whatever it gave (or 'disconnected')
  displayStatus = netStatus || 'disconnected';
}

		const ageGroup =
  		this.state.ageGroup != null
       ? this.state.ageGroup
       : (roomConfig ? Number(roomConfig.ageGroup) : null);

		
		const age = (this.state.ageGroup !== undefined && this.state.ageGroup !== null)
  		? this.state.ageGroup
  		: (roomConfig ? roomConfig.ageGroup : null);
		let isValidTest = false;
		const hasTestIndex = !!(roomConfig && roomConfig.currentTest !== null && roomConfig.currentTest !== undefined);



  isValidTest = Boolean(roomConfig && roomConfig.currentTest != null);
			let CurrentTestAdminPage = null;

			  	let testNumbers = {};
  	let testNumbersArray = [];
let currentSubTest = null;

if (isValidTest) {
  // If ageGroup still not ready or the backend has snet undefined
  if (ageGroup == null || !Number.isFinite(Number(ageGroup))) {
    return (
      <div className="TestAdmin">
       
        <div className="TestAdmin__header">
          <h1>{strings.testadministrator}</h1>
        </div>

        <p className="roomkey">
          {strings.formatString(strings.roomkey, <b>{roomConfig.key}</b>)}
        </p>

        <p style={{ padding: 16 }}>
          {'Venter på testkandidat…'}
        </p>
      </div>
    );
  }
  if (roomConfig && hasTestIndex) {

  /* console.log('Waiting for valid ageGroup, got:', roomConfig.ageGroup, typeof roomConfig.ageGroup); */

  try {
    const hasValidAge = (age === 0) || (typeof age === 'number' && !isNaN(age)) || (typeof age === 'string' && age.length > 0);
	const plan = hasValidAge ? tryGetTestsForClass(age, this.props.testKeyType) : null;
if (plan) {
    const testNumber = roomConfig.currentTest;
    const testName = plan[testNumber];
    if (testName) {
      const comp = getTestFromName(testName); // mapped to component class
      if (comp) {
        isValidTest = true;
        CurrentTestAdminPage = comp;
        currentSubTest = testName;
        testNumbers = plan;
      } else {
        console.warn('Unknown test component for name:', testName);
      }
    } else {
      console.warn('No testName for testNumber', testNumber, 'in plan for age', age);
    }
  } else {
    console.log('Waiting for valid age/plan. age=', age);
  }

  } catch (e) {
  }
}
  /* const testNumber = roomConfig.currentTest;
			const testName = getNameFromNumber(
				testNumber,
				ageGroup,
				this.props.testKeyType
			);
			currentSubTest = testName;
			CurrentTestAdminPage = getTestFromName(testName);

			testNumbers = getTestsForClass(ageGroup, this.props.testKeyType); */

}
	 testNumbersArray = Object.entries(testNumbers);


		return (
			<div className="TestAdmin" onKeyDown={this.handleKeyPress}>
				{roomConfig && isValidTest && (
					<ProgressIndication
						tests={testNumbersArray}
						roomConfig={roomConfig}
					/>
				)}
				<ConnectionStatus
					lastServerPong={lastServerPong}
					lastClientPong={lastClientPong}
					netStatus={displayStatus}
  					netHint={displayHint}
				/>
				<div className="TestAdmin__header">
					<h1>{strings.testadministrator}</h1>
					<div className="center">
						{isValidTest && (
							<form
								onSubmit={(e) =>
									this.goToTest(e, this.testSelect.value)
								}
								className="GoToTestForm"
							>
								<p>
									<select
										ref={(node) => (this.testSelect = node)}
									>
										{testNumbersArray.map(
											([key, value]) => (
												<option value={key} key={key}>
													{
														strings[
															'testName_' + value
														]
													}
												</option>
											)
										)}
									</select>
									<button type="submit">
										{strings.jumptotest}
									</button>
								</p>
							</form>
						)}
					</div>
				</div>
				{roomConfig && (
					<Fragment>
						<p className="roomkey">
							{strings.formatString(
								strings.roomkey,
								<b>{roomConfig.key}</b>
							)}
						</p>
						{!isValidTest && this.returnProperTestIntro(false, roomConfig)}
						{isValidTest && (
							<CurrentTestAdminPage
								currentStage={roomConfig.currentStage}
								currentStep={roomConfig.currentStep}
								stepData={roomConfig.stepData}
								candidateReady={roomConfig.candidateReady}
								ageGroup={roomConfig.ageGroup}
								startTimer={this.startTimer}
								endTimer={this.endTimer}
								nextStep={this.nextStep}
								nextStage={this.nextStage}
								nextTest={this.nextTest}
								testKeyType={this.props.testKeyType}
								submitResults={this.submitResults}
								updateStepData={this.updateStepData}
								derivedFrom={'testAdmin'}
							/>
						)}
					</Fragment>
				)}
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	const {user, token} = state.auth;

	return {
		user,
		token,
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TestAdmin);
